/**
 * Generates a cryptographically strong random id. Prefers WebCrypto's UUID;
 * falls back to crypto.getRandomValues in non-secure contexts where randomUUID
 * is unavailable. Never uses Math.random — callers gate bearer-token release
 * and install correlation on this, so the PRNG must be cryptographically strong.
 */
export function secureRandomId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.getRandomValues === 'function'
  ) {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  }
  throw new Error('Web Crypto API unavailable: cannot generate secure id.');
}
